export default __webpack_public_path__ + "static/header-devel-ec917d007757c7a617d5608f0f3b5c7a.png";